<template>
   <div class="bgbody">
   <div>
   <van-swipe :autoplay="3000">
     <van-swipe-item v-for="(image, index) in images" :key="index" height="150">
       <img :src="image" width="100%" height="150"/>
     </van-swipe-item>
   </van-swipe>
   </div>
      <div style="padding: 10px;">
         <p>山东晟厚网络科技有限公司成立于2015年4月，注册资本1000万元人民币，是一家集信息技术服务和软件开发、生产于一体的国家级高新技术企业。公司拥有专业的团队、完善的制度、良好的售后服务、坚持创新的管理理念。公司业务涵盖信息系统咨询与服务、软件开发、系统集成、信息安全与服务，专心致力于各行业信息化建设。</p>
<p>我公司拥有各类专业技术及服务人才，竭力为广大客户提供国内先进的软件产品、一流的服务和全面的信息系统解决方案，致力成为中国一流的软件研发、技术服务和全面解决方案的提供商。尤其是在互联网+政务服务系统建设方面，得到省市各级政府部门的青睐。</p>
<p>创新是企业的灵魂，管理是企业的保证，我公司投入大量的资金进行产品研发与人员培训交流工作，不断推出新产品和新技术。</p>
<p>质量是企业的生命，公司严格遵循ISO9001质量认证体系的标准。在项目开发和实施方面实行项目经理负责制，并以此为基础，建立完善的内部项目开发和实施的质量管理体系。</p>
<p>“创新、合作、诚信、共赢”是公司发展的理念，为用户和合作伙伴创造价值是我们不懈的追求。明确公司定位，确立公司使命，与公司员工秉持共同的愿景，共建美好明天。</p>
<p>服务宗旨：及时、专业、高效</p>
<p>服务理念：诚信、规范、创新</p>
<p>业务作风：诚信做人，忠厚做事。每天都以热情和微笑对待每一位客户</p>
<p>企业价值：以领先的技术和诚信的服务与每一位客户共赢</p>
<p>地址：山东省济南市历下区历山路27号万科海晏门中心商业办公综合楼1509</p>
<p>电话：0531-85739535</p>
<p><strong>典型客户案例：</strong></p>
<p>山东省公安厅      互联网+民生警务平台</p>
<p>山东省大数据局    “爱山东”公安专栏</p>
<p>济南市公安局       济南E警通         </p>
<p>东营市公安局       东营微警务        </p>
<p>济宁市公安局       济宁微警务        </p>
<p>威海市公安局       威海微警务         </p>
<p>滨州市公安局       滨州微警务         </p>
<p>聊城市公安局       聊城微警务 </p>
<p>枣庄市公安局      枣庄微警务</p>
<p>潍坊市公安局      潍坊微警务</p>
<p>泰安市公安局      泰山E警</p>
<p>德州市公安局      德州警方在线</p>
<p>菏泽市公安局      菏泽微警   </p>
<p><strong>公司部分产品：</strong></p>
<p>晟厚互联网+政务服务平台</p>
<p>晟厚市级承载平台</p>
<p>晟厚互联网+快警可视化指挥平台</p>
<p>晟厚互联网+码上办平台</p>
<p>晟厚互联网+民生警务平台</p>
<p>晟厚互联网+微警务平台</p>
<p>基于信创环境的民生警务平台</p>
<p>晟厚案知道系统</p>
<p>晟厚民生警务综合一体机平台</p>
<p>晟厚政务服务地图系统</p>
<p>基于人脸的核验系统</p>
<p>邮寄速递业务平台</p>
<p>晟厚生态环境综合管控分析平台</p>
<p>海岸业务系统</p>
<p>国际合作业务处理系统</p>
<p>辅警招聘系统</p>
<p>晟厚保安员备案考试系统</p>
<p>晟厚社会治理系统</p>
<p>晟厚基础开发平台</p>
<p>晟厚协同办公系统</p>
<p>晟厚电子监察系统</p>
<p>晟厚行政审批系统</p>
<p>晟厚可视化展示系统</p>
<p>晟厚内容管理系统</p>
<p>晟厚数字档案管理系统</p>
<p>晟厚全文搜索引擎系统</p>
<p>晟厚政务服务热线管理软件系统</p>
<p>晟厚综合考评系统</p>
<p>……      </p>
</div>
   <van-divider
     :style="{ color: '#1989fa', borderColor: '#1989fa', padding: '0 16px' }"
   >
     <van-image
     width="50"
     height="50"
     src="../../static/images/gslogo.png"
   />
   </van-divider>
   <van-row style="font-size:14px;">
     <van-col span="24">山东晟厚网络科技有限公司</van-col>
   </van-row>
   <van-row style="font-size:14px;">
     <van-col span="24"><a style="color:#303D4E" href="https://beian.miit.gov.cn/">备案号：鲁ICP备20030160号</a></van-col>
   </van-row>
   </div>
   </template>
   <script>
    import Vue from 'vue';
    import { Swipe, SwipeItem } from 'vant';
    import { Grid, GridItem } from 'vant';
    import { Image as VanImage } from 'vant';
    import { Circle } from 'vant';
    import { Lazyload } from 'vant';
    import { Divider } from 'vant';
    import $ from 'jquery'
    import { Col, Row } from 'vant';
   
   Vue.use(Divider);
   Vue.use(Lazyload);
   Vue.use(VanImage);
   Vue.use(Grid);
   Vue.use(GridItem);
   Vue.use(Swipe);
   Vue.use(SwipeItem);
   Vue.use(VanImage);
   Vue.use(Col);
   Vue.use(Row);
   //animate.min.css
     export default {
       data() {
       return {
          images: [
           '../../static/images/banner3.png',
           '../../static/images/banner.jpg'
         ]
       };
     },
       name: 'WJWList',
       methods:{
       },
       mounted(){
          try {
       window.console && window.console.log && (console.log("山东晟厚网络科技有限公司欢迎你的加入，招贤电话：0531-85739535。")); 
       }catch (e) {}
       }
     }
   </script>
   <style>
   p{
      text-align: left;
      font-size: 15px;
      text-indent: 30px;
      line-height: 200%;
       margin: 0;
       padding: 0;
   }
     .my-swipe .van-swipe-item {
       color: #fff;
       font-size: 20px;
       line-height: 150px;
       text-align: center;
       background-color: #39a9ed;
     }
     .mfont{
       font-size:14px;
       line-height:250%;
       font-weight:bold;
     }
     .bgbody{
        background-repeat:no-repeat;
        background-position:center;
     }
   </style>


// WEBPACK FOOTER //
// src/components/GSJS.vue